const getDomElementByName = name => document.querySelector(`#CarsSearchForm [name="${name}"]`);

export default getDomElementByName;
